import React, { useContext, useState, useRef } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { ShopContext } from '../../data/shop/ShopConf';
import { getConfiguration } from '../../data/utils';
import { getLabel } from '../../data/labels';
import ReservationHistory from './ReservationHistory';

import './ReservationBox.css';

function ReservationBox(props) {
	const betslipContext = useContext(BetslipContext);
    const shopContext = useContext(ShopContext);
    const conf = getConfiguration();
    const [reservationCode, setReservationCode] = useState('');
    
    const usageMode = window.appConfig.usageMode;
    const keyboardEnabled = usageMode && usageMode.indexOf('touch') >= 0;

    const [virtualKeyboardShown, setVirtualKeyboardShown] = useState(false);
    const keyboardRef = useRef(null);

    function showVirtualKeyboard() {
    	setVirtualKeyboardShown(true && keyboardEnabled);
    }
    function hideVirtualKeyboard() {
    	setVirtualKeyboardShown(false);
    }
    
    function toggleVirtualKeyboard() {
    	if (virtualKeyboardShown) {
    		hideVirtualKeyboard();
    	} else {
    		showVirtualKeyboard();
    	}
    }

    function loadTicket() {
        if (reservationCode?.length > 0) {
            betslipContext.reloadReservedTicket(reservationCode);
        }
    }

    function handleChange(value) {
        setReservationCode(value);
        if (keyboardRef.current) {
            keyboardRef.current.value = value;
        }    
    }
	const couponKey = props.couponKey;
    let reservations = betslipContext.getReservations() || [];
    
    const fastbetAliasEnabled = shopContext.enabled && conf.fbt === 'XR';

    return (
        <div className="cart__body">
            <div id="tab-prenotazioni" className={fastbetAliasEnabled? 'adj-margin-top' : ''}>
                <div className="padding-orizzontale padding-verticale text-center">
                    {!window.appConfig.TERMINAL_AGENCY && (
                        <p className="disclaimerReservation">
                            {getLabel('betslip_alt.reservation.disclaimer_part1').replaceAll('{{DAYS}}', conf.rps?.edr || 3)} 
                            {getLabel('betslip_alt.reservation.disclaimer_part2')}
                        </p>
                    )}
                    <br />
                    <p className="reservationInputLabel">{getLabel('betslip_alt.reservation.label_part1')} <span className={"grassetto"}>{couponKey}</span> {getLabel('betslip_alt.reservation.label_part2')}</p>
                    <div className="cart__reservationInput">
                        <input className="input" 
                               type="text" 
                               id="input-reservation-box-coupon-1" 
                               placeholder={getLabel('betslip_alt.reservations.code')} 
                               value={reservationCode} 
                               onClick={() => toggleVirtualKeyboard()}
                               onChange={e => handleChange(e.target.value + '')}
                        />
                        <a className="button clickable" onClick={() => loadTicket()}>{getLabel('betslip_alt.reservations.load')}</a>
                    </div>
                    {reservations.length > 0 &&
                        <ReservationHistory reservations={reservations} />
                    }
                </div>
            </div>
        </div>
   );
}

export default ReservationBox;